import React, { Component } from 'react';
import { Link } from 'react-router-dom'

var lodash = require('lodash')

class List extends Component {

  constructor(props) {
    super(props);

    this.state = {
      fonctions: [],
      allFonction: [],
      filterName: '',
    }
  }

  componentWillMount() {
    this.fetchFonctions();
  }

  fetchFonctions() {
    fetch(localStorage.backoffice_api + '/api/fonctions', {
      method: 'GET',
      headers: {
        authorization: localStorage.JWT,
      }
    })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then((json) => {
      var fonctions = lodash.sortBy(json, (f) => {
        return f.Descr;
      })

      this.setState({
        fonctions: fonctions,
        allFonction: fonctions,
      });
    })
    .catch((error) => {
      console.log(error)
    });
  }

  filter(event){
    var fonctions = this.state.allFonction;
    var filterName = event.target.value;
    fonctions = fonctions.filter((f) => {
      return f.Descr.toLowerCase().search(filterName.toLowerCase()) !== -1
    });
    this.setState({
      fonctions: fonctions,
      filterName: filterName
    });
  }

  render() {

    return (
      <div className='container-fluid'>
        <div className="row">
          <div className="col">

            <h2>Fonctions</h2>

            <br />

            <div>
              <Link to='/fonctions/create' className='btn btn-light'>
                <i className="fa fa-plus"></i> Ajouter
              </Link>

              <div className='float-right'>
                <div className="form-inline" style={{ marginTop: '2px' }}>
                  <div className="input-group">
                    <span className="input-group-addon" id="basic-addon1"><i className='fa fa-filter'></i></span>
                    <input type='search' className='form-control form-control-sm float-right' value={this.state.filterName} onChange={(e) => this.filter(e)} placeholder='Filtre par nom' />
                  </div>
                </div>
              </div>
            </div>

            <br />

            <table className="table table-striped table-hover table-sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nom</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
              {
                this.state.fonctions.map((f) => {
                  return (<tr key={"fonction"+f.IDFonction}>
                    <td>{f.IDFonction}</td>
                    <td>{f.Descr}</td>
                    <td className="text-right">
                      <Link to={'/fonctions/'+f.IDFonction} className='btn btn-primary btn-sm'>
                        <i className="fa fa-pencil"></i>
                      </Link>
                    </td>
                  </tr>);
                })
              }
              </tbody>
            </table>

          </div>
        </div>
      </div>
    );
  }
}

export default List;
